import { isMobileBrowser } from "../base/environment/utils";
import { SET_TILE_VIEW, VIRTUAL_SCREENSHARE_REMOTE_PARTICIPANTS_UPDATED, } from "./actionTypes";
// @ts-ignore
import { shouldDisplayTileView } from "./functions";
// @ts-ignore
import { getStore, isIpad } from "../customise/Utils";
/**
 * Creates a (redux) action which signals that the list of known remote virtual screen share participant ids has
 * changed.
 *
 * @param {string} participantIds - The remote virtual screen share participants.
 * @returns {{
 *     type: VIRTUAL_SCREENSHARE_REMOTE_PARTICIPANTS_UPDATED,
 *     participantIds: Array<string>
 * }}
 */
export function virtualScreenshareParticipantsUpdated(participantIds) {
    return {
        type: VIRTUAL_SCREENSHARE_REMOTE_PARTICIPANTS_UPDATED,
        participantIds,
    };
}
/**
 * Creates a (redux) action which signals to set the UI layout to be tiled view
 * or not.
 *
 * @param {boolean} enabled - Whether or not tile view should be shown.
 * @returns {{
 *     type: SET_TILE_VIEW,
 *     enabled: ?boolean
 * }}
 */
// CUSTOM
export const setTileView = (enabled) => {
    const isChatOpen = getStore("features/chat")?.isOpen;
    const isParticipantOpen = getStore("features/participants-pane")?.isOpen;
    if ((isMobileBrowser() || isIpad()) && (isChatOpen || isParticipantOpen)) {
        return {};
    }
    return {
        type: SET_TILE_VIEW,
        enabled,
    };
};
// END
/**
 * Creates a (redux) action which signals either to exit tile view if currently
 * enabled or enter tile view if currently disabled.
 *
 * @returns {Function}
 */
export function toggleTileView() {
    return (dispatch, getState) => {
        const tileViewActive = shouldDisplayTileView(getState());
        // @ts-ignore
        dispatch(setTileView(!tileViewActive));
    };
}
